module.exports = __webpack_public_path__ + "img/morningRef2.26f9a0f6.jpg";